import { contentLanguage, language } from '../types'

type OptionalLanguage = Exclude<language, contentLanguage>
type Localized<T> = Record<contentLanguage, T> & Partial<Record<OptionalLanguage, T>>

export const contentLang = (lang: language): contentLanguage => {
  if (lang === 'TW') return 'ZH'
  if (lang === 'KO') return 'EN'
  return lang
}

export const langPathPrefix = (lang: language) => {
  if (lang === 'JA') return ''
  return `/${lang.toLowerCase()}`
}

export const pathWithTrailingSlash = (path = '') => {
  if (/^[a-z][a-z\d+.-]*:\/\//i.test(path)) return path

  const [pathname, suffix = ''] = path.split(/([?#].*)/, 2)
  const normalizedPathname = `/${pathname || ''}`.replace(/\/{2,}/g, '/')

  if (normalizedPathname === '/') return `/${suffix}`
  if (normalizedPathname.endsWith('/')) return `${normalizedPathname}${suffix}`

  return `${normalizedPathname}/${suffix}`
}

export const localizedPath = (lang: language, path = '/') =>
  pathWithTrailingSlash(`${langPathPrefix(lang)}${path}`)

export const langFromPath = (pathname: string): language => {
  const match = pathname.match(/^\/(en|zh|tw|ko)(\/|$)/)
  if (!match) return 'JA'

  return match[1].toUpperCase() as language
}

export const localize = <T,>(values: Localized<T>, lang: language): T =>
  values[lang as keyof Localized<T>] ?? values[contentLang(lang)]
